import { I18n } from '@calendly/i18n'
import { SimplePopup } from '@calendly/ui/components/popup'
import { RadioInput } from '@calendly/ui/components/radio-input'
import { BodyText } from '@calendly/ui/components/typography'
import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'


import { DomainControlNotice } from '../domain_control_notice'
import { isRemovePopupOpenSelector, membershipToRemoveSelector, isRemovingLoadingSelector } from '../selectors'
import { closeRemoveUserPopup, removeUserAndCloseModal, deleteUserAndCloseModal } from '../slice'
import { Wrapper, RemovalOption, Label, LabelText, Description, Warning, RemovalOptionWrapper } from './shared'

export const RemoveUser = () => {
  const dispatch = useDispatch()

  const membershipToRemove = useSelector(membershipToRemoveSelector)
  const isOpen = useSelector(isRemovePopupOpenSelector)

  const isRemovingLoading = useSelector(isRemovingLoadingSelector)
  const [willDelete, setWillDelete] = useState(false)
  const [action, setAction] = useState('remove')

  if (!membershipToRemove) {
    return null
  }

  const canDeleteUser = membershipToRemove.policy.delete_user

  const handleActionChanged = (event) => {
    setAction(event.target.value)
    setWillDelete(event.target.value === 'delete')
  }
  const handleClose = () => { dispatch(closeRemoveUserPopup()) }
  const handleSubmit = willDelete
    ? () => dispatch(deleteUserAndCloseModal())
    : () => dispatch(removeUserAndCloseModal())

  return (
    <SimplePopup
      isOpen={isOpen}
      onClose={handleClose}
      title={I18n.t('publisher.organization.members.remove_user')}
      confirmLabel={willDelete ? I18n.t('publisher.action.delete') : I18n.t('publisher.action.remove')}
      onConfirm={handleSubmit}
      isLoading={isRemovingLoading}
      cancelLabel={I18n.t('publisher.action.cancel')}
    >
      <Wrapper>
        <BodyText weight="bold">{membershipToRemove.name}</BodyText>
        <RemovalOptionWrapper>
          <RemovalOption>
            <Label>
              <RadioInput id="remove-user" name="action" value="remove" checked={action === 'remove'} onChange={handleActionChanged} />
              <LabelText>{I18n.t('publisher.organization.members.remove')}</LabelText>
            </Label>
            <Description>
              {I18n.t('publisher.organization.members.remove_explanation')}
            </Description>
          </RemovalOption>
          <RemovalOption disabled={!canDeleteUser}>
            <Label>
              <RadioInput
                id="delete-user"
                name="action"
                value="delete"
                checked={action === 'delete'}
                onChange={handleActionChanged}
                disabled={!canDeleteUser}
              />
              <LabelText>{I18n.t('publisher.organization.members.remove_and_delete')}</LabelText>
            </Label>
            <Description>
              {I18n.t('publisher.organization.members.remove_and_delete_explanation')}
            </Description>
            {willDelete && (
            <Warning>
              {I18n.t('publisher.organization.members.delete_warning')}
            </Warning>
            )}
          </RemovalOption>
        </RemovalOptionWrapper>
      </Wrapper>
      <DomainControlNotice memberships={[membershipToRemove]} remove />
    </SimplePopup>
  )
}
